import * as React from "react"
import * as Primitives from "@radix-ui/react-label"
import { clx } from "../utils/clx"

interface LabelProps
  extends React.ComponentPropsWithoutRef<"label"> {
  required?: boolean
}

/**
 * This component is based on the [Radix UI Label](https://www.radix-ui.com/primitives/docs/components/label) primitive.
 */
const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({
    className,
    required = false,
    children,
    ...props
  }: LabelProps, ref) => {
    return (
      <Primitives.Root
        ref={ref}
        className={clx(
          "txt-small-regular-plus text-ui-fg-subtle flex w-full items-center",
          className
        )}
        {...props}
      > 
        {children}
        {required && <div className="text-red-base">&nbsp;*</div>}
      </Primitives.Root>
    )
  }
)
Label.displayName = "Label"

export { Label, LabelProps }
